import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import { natureOfConstructionOptions, planOnOptions, statesName, yesOrNo } from "../../../../TCPForms/data";
import FileUploader from "../../../reusableComponents/FileUploader2";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { useHistory } from "react-router-dom";
import RemarksEditor from "../../../../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import { Grid } from "@mui/material";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { FaFilePdf } from "react-icons/fa";
import { useSelector } from "react-redux";
import { addYearsToEpoch, convertEpochToDate } from "../../../../../../utils";

const SubStep1 = ({
  formData,
  handleSubTabChange,
  userInfo,
  isEmployee = false,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
}) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1");
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const tenantId = Digit.ULBService.getStateId();
  const { documents } = useSelector((state) => state.formMT);
  const history = useHistory();
  const inputWidth = 200;
  const checklist = formData?.landInfo?.checklistdata;
  const [error, setError] = useState("");
  const [remarks, setRemarks] = useState("");
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(Digit?.SessionStorage.get("EMP_MAPSUB") || null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [dwgPdf, setDwgPdf] = useState(null);
  const [appPdf, setAppPdf] = useState(null);
  const [dwgPdfUrl, setDwgPdfUrl] = useState(formData?.drawingPdf);
  const [approvalUrl, setApprovalUrl] = useState(formData?.approvalCertificateUrl);

  const [
    watchPlanOn,
    watchnatureOfConstruction,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchLandMark,
    watchState,
    watchCity,
    watchPin,
    watchAddress,
    watchConsultantCateogry,
    watchProfName,
    watchProfEmailId,
    watchProfMobileNo,
    watchCertNo,
    watchValidUpto,
    watchName,
    watchMobileNo,
    watchEmailId,
    watchProposalType,
    watchSchemeName,
    watchTehsil,
    watchVillage,
    watchSectorNo,
    watchKhasraNo,
    watchPlotNo,
    watchLatitude,
    watchLongitude,
    watchApplication,
    watchLayoutSanctionDate,
    watchValidity,
  ] = watch([
    "planOn",
    "natureOfConstruction",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "landMark",
    "landInfo.owners.[0].correspondenceAddress.state",
    "landInfo.owners.[0].correspondenceAddress.town",
    "landInfo.owners.[0].correspondenceAddress.pinno",
    "landInfo.owners.[0].correspondenceAddress.address",
    "professionaldetails.consultantCategory",
    "professionaldetails.name",
    "professionaldetails.emailId",
    "professionaldetails.mobileNumber",
    "professionaldetails.certificateNo",
    "professionaldetails.validupto",
    "landInfo.owners.[0].name",
    "landInfo.owners.[0].mobileNumber",
    "landInfo.owners.[0].emailId",
    "proposalType",
    "schemeName",
    "tehsil",
    "revenueVillage",
    "sectorNo",
    "khasraNo",
    "plotNo",
    "descriptionOfLand.latitude",
    "descriptionOfLand.longitude",
    "applicationNo",
    "layoutsanctionDate",
    "validity",
  ]);

  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);

  useEffect(() => {
    const alldocs = fastPASData?.documents;
    if (Array.isArray(alldocs) && Array.isArray(documents) && !isEmployee) {
      const mergedDocs = [...(alldocs || []), ...(documents || [])];
      setValue("documents", mergedDocs);
    }
    if (isEmployee) {
      setValue("documents", documents);
    }
  }, [documents]);

  useEffect(() => {
    if (isEmployee && formData?.documents?.length > 0) {
      const approvalLetterUrl = formData?.documents?.find((doc) => doc.documentType === "approvalLetter")?.fileStoreId || null;
      setAppPdf(approvalLetterUrl);
      const drawingPdfUrl = formData?.documents?.find((doc) => doc.documentType === "drawingPdf")?.fileStoreId || null;
      setDwgPdf(drawingPdfUrl);
    }
  }, [isEmployee, formData?.documents]);

  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        response = await Digit.OBPSService.BPASearch(tenantId, { applicationId: id });
        console.log(response, "responsefromId");
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this Application No...!!`,
          });
          return;
        }
        data = response?.BPA?.[0];
        if (!data?.status?.includes("APPROVED")) {
          setShowToast({
            key: "true",
            error: true,
            message: `Application is not Approved Yet...!!`,
          });
          return;
        }

        console.log(" DAtsaystyas", data?.documents);
        setFastPasData(data);
        const drawingPdfs = data?.documents?.filter((e) => e.documentType === "drawingPdf");
        setDwgPdf(drawingPdfs?.[0]?.fileStoreId);
        const approvalPdfs = data?.documents?.filter((e) => e.documentType === "approvalLetter");
        setAppPdf(approvalPdfs?.[0]?.fileStoreId);
        if (data) {
          // const uuid = userInfo?.uuid;
          // if (uuid) {
          //   const usersResponse = await Digit.UserService.userSearch(tenantId, { uuid: [uuid] }, {});
          //   const userDetail = usersResponse?.user?.[0];
          //   Digit.SessionStorage.set("USER_DETAIL", userDetail);
          //   setUser(userDetail);
          //   if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
          //     setShowToast({
          //       key: "true",
          //       error: false,
          //       message: `Data fetched Successfully...!!`,
          //     });
          //   }
          setDwgPdfUrl(data?.drawingPdf);
          setApprovalUrl(data?.approvalCertificateUrl);
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`,
          });
        }
        setValue("zoneType", data?.descriptionOfLand?.landUsesType);
        setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("natureOfConstruction", data?.natureOfConstruction);
        setValue("sanctionNumber", data?.sanctionNumber);
        const lastModifiedTime = data?.auditDetails?.lastModifiedTime;
        setValue("layoutsanctionDate", convertEpochToDate(lastModifiedTime));
        setValue("validity", convertEpochToDate(addYearsToEpoch(lastModifiedTime, 5)));
        setValue("revenueVillage", data?.revenueVillage || data?.descriptionOfLand?.khasraDetails?.[0]?.village);
        // setValue("landMark", data?.landMark);
        setValue("sectorNo", data?.sectorNo);
        // setValue("khasraNo", data?.khasraNo);
        setValue("plotNo", data?.plotNo || data?.descriptionOfLand?.khasraDetails?.[0]?.plotNo || data?.descriptionOfLand?.plotNo);
        setValue("descriptionOfLand.latitude", data?.descriptionOfLand?.latitude);
        setValue("descriptionOfLand.longitude", data?.descriptionOfLand?.longitude);
        setValue("descriptionOfLand.schemeType", data?.descriptionOfLand?.schemeType);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("riskType", data?.riskType);
        setValue("planOn", "plinth_submission");
        setValue("selectedOffice", "Lucknow Development Authority");
        setValue("department", data?.department);
        setValue("businessService", "BPA_MAPPLINTH_DA");
        setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
        setValue("proposalType", data?.proposal);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("siteAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.descriptionOfLand?.khasraDetails?.[0]?.tehsil);
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);

        setValue(
          "professionaldetails.consultantCategory",
          data?.professionaldetails?.consultantCategory || data?.professionalInformation?.consultantCategory
        );
        setValue("professionaldetails.name", data?.professionaldetails?.name || data?.professionalInformation?.name);
        setValue("professionaldetails.emailId", data?.professionaldetails?.emailId || data?.professionalInformation?.eremailId);
        setValue("professionaldetails.mobileNumber", data?.professionaldetails?.mobileNumber || data?.professionalInformation?.ermobileNumber);
        setValue("professionaldetails.certificateNo", data?.professionaldetails?.certificateNo || data?.professionalInformation?.certificateNo);
        setValue("professionaldetails.validupto", data?.professionaldetails?.validupto || data?.professionalInformation?.validupto);

        setValue("landInfo.owners.[0].name", data?.professionaldetails?.consultantCategory);
        setValue("landInfo.owners.[0].name", data?.landInfo?.owners?.[0]?.name);
        setValue("landInfo.owners.[0].emailId", data?.landInfo?.owners?.[0]?.emailId);
        setValue("landInfo.owners.[0].mobileNumber", data?.landInfo?.owners?.[0]?.mobileNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.state", data?.landInfo?.owners?.[0]?.correspondenceAddress?.state);
        setValue("landInfo.owners.[0].correspondenceAddress.town", data?.landInfo.owners?.[0]?.correspondenceAddress?.town);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", data?.landInfo.owners?.[0]?.correspondenceAddress?.pinno);
        setValue("landInfo.owners.[0].correspondenceAddress.address", data?.landInfo.owners?.[0]?.correspondenceAddress?.address);

        setValue("blocks.[0].setBacks.[0].frontYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.frontYard?.minimumDistance);
        setValue("blocks.[0].setBacks.[0].rearYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.rearYard?.minimumDistance);
        setValue("blocks.[0].setBacks.[0].sideYard1.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.sideYard1?.minimumDistance);
        setValue("blocks.[0].setBacks.[0].sideYard2.minimumDistance", data?.blocks?.[0]?.setBacks?.[0]?.sideYard2?.minimumDistance);

        setValue("blocks.[0].setBacks.[1].frontYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.frontYard?.minimumDistance);
        setValue("blocks.[0].setBacks.[1].rearYard.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.rearYard?.minimumDistance);
        setValue("blocks.[0].setBacks.[1].sideYard1.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.sideYard1?.minimumDistance);
        setValue("blocks.[0].setBacks.[1].sideYard2.minimumDistance", data?.blocks?.[0]?.setBacks?.[1]?.sideYard2?.minimumDistance);

        setValue("landInfo.checklistdata.plinthHeight", data?.blocks?.[0]?.plinthHeight?.[0]);

        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        setSchemeType(isApproved);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  console.log("SchemeTYope", schemeType);

  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);

  const onSubmit = (data) => {
    let final = { ...fastPASData, ...data };
    if (isEmployee) {
      handleTabChange(2, final);
    } else {
      final.khasraRemarks = remarks;
      handleTabChange(1, final);
    }
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="APPLICATION NO"
                  placeholder="Enter Application NO."
                  name="applicationNo"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.applicationNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("applicationNo"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Licensed Technical Person (LTP)")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Consultant Category")}`}
                  placeholder={`${t("Cosultant Category")}`}
                  name="professionaldetails.consultantCategory"
                  defaultValue={formData?.professionaldetails?.consultantCategory || formData?.professionalInformation?.consultantCategory}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchConsultantCateogry}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_APPLICANT_NAME")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="professionaldetails.name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.professionaldetails?.name}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || watchProfName}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="professionaldetails.emailId"
                  defaultValue={formData?.professionaldetails?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={isEmployee || watchProfEmailId}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="professionaldetails.mobileNumber"
                  defaultValue={formData?.professionaldetails?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={isEmployee || watchProfMobileNo}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                {/* <InputWrapper
                  label="Certificate No. (For Minimum Qualification)"
                  control={control}
                  placeholder="Enter Certificate No"
                
                  defaultValue={formData?.professionaldetails?.certificateNo}
                  disabled={isEmployee}
                /> */}
                  <InputWrapper
                  label="Certificate No. (For Minimum Qualification)"
                  control={control}
                  placeholder="Enter Certificate No"
                  maxLength={13}
                  type="textInput"
                  name="professionaldetails.certificateNo"
                  defaultValue={formData?.professionaldetails?.certificateNo}
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                {" "}
                {/* <InputWrapper
                  label={t("LABEL_VALID_UPTO")}
                  control={control}
                  placeholder="Select Date"
                  type="datePicker"
                  name="professionaldetails.validupto"
                 
                  disabled={isEmployee || watchValidUpto}
                /> */}
                   <InputWrapper
                  label={t("LABEL_VALID_UPTO")}
                  control={control}
                  placeholder="Select Date"
                  type="datePicker"
                  name="professionaldetails.validupto"
                  defaultValue={formData?.professionaldetails?.validupto}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchValidUpto}
                />
              </Col>
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Owner Information")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Name")}
                  control={control}
                  placeholder={t("LABEL_ENTER_NAME")}
                  name="landInfo.owners.[0].name"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.landInfo?.owners?.[0]?.name}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || watchName}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Enter Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="landInfo.owners.[0].mobileNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                  disabled={isEmployee || watchMobileNo}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("LABEL_EMAIL_ID")}
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="landInfo.owners.[0].emailId"
                  defaultValue={formData?.landInfo?.owners?.[0]?.emailId}
                  type="textInput"
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={isEmployee || watchEmailId}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_STATE")}
                  placeholder={t("LABEL_ENTER_STATE")}
                  name="landInfo.owners.[0].correspondenceAddress.state"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.state}
                  type="selectInput"
                  data={statesName}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchState}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("LABEL_CITY")}
                  placeholder={watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_CITY")}
                  name="landInfo.owners.[0].correspondenceAddress.town"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.town}
                  type={watchState === "Uttar Pradesh" ? "selectInput" : "textInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchCity}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_PINCODE")}
                  placeholder={t("LABEL_ENTER_PINCODE")}
                  name="landInfo.owners.[0].correspondenceAddress.pinno"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pincode",
                    },
                  }}
                  maxLength={6}
                  disabled={isEmployee || watchPin}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  name="landInfo.owners.[0].correspondenceAddress.address"
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  maxLength={50}
                  disabled={isEmployee || watchAddress}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Plot Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchlandUseType}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchSubZoneType}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchPrimaryUse}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchAtivityProposed}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(planOnOptions)}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="proposalType"
                  defaultValue={formData?.proposalType}
                  type="selectInput"
                  disabled={isEmployee || watchProposalType}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={"Other Proposed Site"}
                    control={control}
                    placeholder={t("Enter Proposed Site")}
                    name="otherSchemeName"
                    mandatory
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Sanction No.")}
                  control={control}
                  placeholder={t("Enter sanction number")}
                  name="applicationNo"
                  defaultValue={formData?.applicationNo || watchApplication}
                  type="textInput"
                  disabled={isEmployee || watchApplication}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Sanction Date")}
                  control={control}
                  placeholder={t("Enter Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  disabled={isEmployee || watchLayoutSanctionDate}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(natureOfConstructionOptions)}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee || watchnatureOfConstruction}
                />
              </Col>

              <Col>
                <InputWrapper
                  label={t("Validity")}
                  control={control}
                  placeholder={t("Select Validity")}
                  name="validity"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.validity}
                  type="datePicker"
                  disabled={isEmployee || watchValidity}
                />
              </Col>
            </Row>

            {schemeType && (
              <Row>
                <Col>
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={SortingAlphabatically(dropDownData?.schemeName)}
                    disabled={isEmployee || watchSchemeName}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  label="Tehsil"
                  control={control}
                  placeholder="Enter Tehsil"
                  defaultValue={formData?.tehsil || formData?.descriptionOfLand?.khasraDetails?.[0]?.tehsil}
                  name={`tehsil`}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              <Col></Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.revenueVillage || formData?.descriptionOfLand?.khasraDetails?.[0]?.village}
                  name={`revenueVillage`}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  maxLength={15}
                  defaultValue={formData?.landMark || formData?.descriptionOfLand?.landMark}
                  type="textInput"
                  disabled={isEmployee || watchLandMark}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Sector/Pocket No.")}
                  control={control}
                  placeholder={t("Enter Sector/Pocket No.")}
                  name="sectorNo"
                  maxLength={15}
                  defaultValue={formData?.sectorNo}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              {/* <Col>
                <InputWrapper
                  label={t("Khasra No.")}
                  control={control}
                  placeholder={t("Enter Khasra No.")}
                  name="khasraNo"
                  maxLength={15}
                  defaultValue={formData?.khasraNo}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col> */}
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Plot No")}
                  control={control}
                  placeholder={t("Enter Plot no")}
                  name="plotNo"
                  mandatory
                  defaultValue={formData?.plotNo || formData?.descriptionOfLand?.khasraDetails?.[0]?.plotNo}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Declaration")}
                  control={control}
                  name="declaration"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Work start date")}
                  control={control}
                  placeholder={t("Select date")}
                  name="workstartDate"
                  defaultValue={formData?.workstartDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Plinth completion date")}
                  control={control}
                  placeholder={t("Select date")}
                  name="workCompletionDate"
                  defaultValue={formData?.workCompletionDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
            </Row>
          </Container>
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Plinth Inspection")}</h2>
            </div>
            <Container fluid className="formInputContainer common-app-form">
              <Row style={{ margin: "10px" }}>
                <Col>
                  <InputWrapper
                    label="Latitude"
                    control={control}
                    placeholder="Enter Latitude"
                    name="descriptionOfLand.latitude"
                    type="specialChar"
                    allowedChars="."
                    onlyNumeric={true}
                    mandatory
                    isRequired={true}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Coordinates"),
                        message: "Value cannot be zero. Please provide valid coordinate.",
                      },
                    }}
                    minLength={8}
                    maxLength={10}
                    disabled={isEmployee || watchLatitude}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label="Longitude"
                    control={control}
                    placeholder="Enter Longitude"
                    name="descriptionOfLand.longitude"
                    type="specialChar"
                    allowedChars="."
                    onlyNumeric={true}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Coordinates"),
                        message: "Value cannot be zero. Please provide valid coordinate.",
                      },
                    }}
                    isRequired={true}
                    maxLength={10}
                    minLength={8}
                    disabled={isEmployee || watchLongitude}
                  />
                </Col>
              </Row>
              <Table striped bordered className="m-0" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "25%" }}>Description</th>
                    <th style={{ width: "25%" }}>As per Plan</th>
                    <th style={{ width: "25%" }}>On Site</th>
                    <th style={{ width: "25%" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Basement Front Setback</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[0].frontYard.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[0]?.frontYard?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.builtupArea"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.builtupArea}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.builtupArea_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.builtupArea_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Basement Rear Setback</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[0].rearYard.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[0]?.rearYard?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.far"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.far}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.far_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.far_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Basement Side Setback - 1</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[0].sideYard1.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[0]?.sideYard1?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.heightOfBuilding"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.heightOfBuilding}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.heightOfBuilding_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.heightOfBuilding_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Basement Side Setback-2</td>

                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[0].sideYard2.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[0]?.sideYard2?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.heightOfFloor"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.heightOfFloor}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.heightOfFloor_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.heightOfFloor_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>

              <Table striped bordered className="m-0" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: "25%" }}>Description</th>
                    <th style={{ width: "25%" }}>As per Plan</th>
                    <th style={{ width: "25%" }}>On Site</th>
                    <th style={{ width: "25%" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Front Setback</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[1].frontYard.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[1]?.frontYard?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.plotAreaForSubdivision"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.plotAreaForSubdivision}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.plotAreaForSubdivision_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.minimumWidthOfPedestrianremarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Rear Setback</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[1].rearYard.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[1]?.rearYard?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.landUse"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.landUse}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.landUse_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.landUse_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Side 1 Setback</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[1].sideYard1.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[1]?.sideYard1?.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.numberOfStoreys"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.numberOfStoreys}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.numberOfStoreys_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.numberOfStoreys_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Side 2 setback</td>

                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="blocks.[0].setBacks.[1].sideYard2.minimumDistance"
                        placeholder={"Enter Details"}
                        defaultValue={formData?.blocks?.[0]?.setBacks?.[1]?.sideYard2.minimumDistance}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.parkingProvision"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.parkingProvision}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.parkingProvision_remarks"
                        placeholder={"Enter Remarks"}
                        defaultValue={checklist?.parkingProvision_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>Plinth Height</td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.plinthHeight"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.plinthHeight}
                        disabled={isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.plinthHeight_relaxation"
                        placeholder={"Enter Details"}
                        defaultValue={checklist?.plinthHeight_relaxation}
                        disabled={!isEmployee}
                      />
                    </td>
                    <td>
                      <InputWrapper
                        width={inputWidth}
                        hasLabel={false}
                        type="textInput"
                        control={control}
                        name="landInfo.checklistdata.plinthHeight_remarks"
                        placeholder={"Enter Remarks"}
                        multiline
                        defaultValue={checklist?.plinthHeight_remarks}
                        disabled={!isEmployee}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Container>
          </div>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Document")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <strong>Drawing PDF</strong>:
                  </Grid>{" "}
                  {/* Label part */}
                  <Grid item xs={6}>
                    {dwgPdfUrl ? (
                      <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} onClick={() => window.open(dwgPdfUrl, "_blank")} />
                    ) : dwgPdf ? (
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px" }}
                        onClick={() => getDocumentByFileStoreId(dwgPdf, setIsPreviewLoading)}
                      />
                    ) : (
                      <FaFilePdf color="#d3d3d3" style={{ width: "20px", height: "30px" }} />
                    )}
                  </Grid>
                </Grid>
              </Col>
              <Col>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <strong>Approval Letter</strong>:
                  </Grid>{" "}
                  {/* Label part */}
                  <Grid item xs={6}>
                    <FaFilePdf
                      color="#a10505"
                      style={{ width: "20px", height: "30px" }}
                      // onClick={() => window.open(approvalUrl, "_blank")}
                      onClick={() => {
                        approvalUrl ? window.open(approvalUrl, "_blank") : getDocumentByFileStoreId(appPdf, setIsPreviewLoading);
                      }}
                    />
                  </Grid>
                </Grid>
              </Col>
            </Row>
            <Row>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Additional Document")}
                  control={control}
                  name="addtionaldocument"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Site Photograph")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={isEmployee ? t("Uploaded by LTP") : t("Upload site photo")}
                  control={control}
                  name="ltpSitePhoto"
                  validationMsg="(.png, .jpg, .jpeg file only and Max file Size 10 MB)"
                  required
                  tab={2}
                />
              </Col>
              {isEmployee ? (
                <Col className="custom-upload new-custom-uploader">
                  <FileUploader
                    isMandatory
                    label={t("Upload")}
                    control={control}
                    name="empSitePhoto"
                    validationMsg="(.png, .jpg, .jpeg file only and Max file Size 10 MB)"
                    required
                    tab={2}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
          </Container>
        </div>

        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Remark")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            {!isEmployee ? (
              <Row>
                <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
              </Row>
            ) : (
              <Row>LTP Remark: {formData?.khasraRemarks}</Row>
            )}
          </Container>
        </div>
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label={isEmployee ? "Save" : "Forward"}
              type="submit"
              sx={{ backgroundColor: "#157CB3" }}
            />
            {/* {!isEmployee && (
              <ButtonWrapper variant="contained" color="success" size="medium" label="Forward" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            )} */}
          </div>
        </div>
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
